/** Textos da tela `/confirmar-assinatura` (pós-checkout Stripe). */

export const VERIFY_SUBSCRIPTION_TITLE = 'Confirmando assinatura';

export const VERIFY_SUBSCRIPTION_LOADING = 'Carregando seu perfil…';

export const VERIFY_SUBSCRIPTION_PROCESSING_TITLE = 'Aguarde um instante';
export const VERIFY_SUBSCRIPTION_PROCESSING_BODY =
  'Estamos confirmando o pagamento com o Stripe. Isso costuma levar poucos segundos. ' +
  'Não feche esta página.';

export const VERIFY_SUBSCRIPTION_SUCCESS_TITLE = 'Assinatura ativa';
export const VERIFY_SUBSCRIPTION_SUCCESS_BODY =
  'Tudo certo. Você será redirecionado para o app.';

export const VERIFY_SUBSCRIPTION_FAILURE_TITLE = 'Não foi possível confirmar';
export const VERIFY_SUBSCRIPTION_FAILURE_BODY =
  'Algo deu errado na assinatura ou o pagamento não foi concluído. ' +
  'Tente escolher o plano novamente ou entre em contato com o suporte.';

export const VERIFY_SUBSCRIPTION_BACK_CTA = 'Voltar aos planos';

export const VERIFY_SUBSCRIPTION_INVALID_ID_BODY =
  'O link de confirmação está incompleto ou inválido. Volte à escolha de planos e inicie o checkout novamente.';

export const VERIFY_SUBSCRIPTION_NOT_FOUND_BODY =
  'Não encontramos este pagamento na sua conta. Se acabou de pagar, aguarde alguns instantes ou tente de novo pela página de planos.';

export const VERIFY_SUBSCRIPTION_LISTEN_ERROR_PREFIX =
  'Não foi possível acompanhar o status do pagamento.';

export const VERIFY_SUBSCRIPTION_STRIPE_HINT =
  'A confirmação segue o registro no RetornaAr assim que o Stripe notificar o servidor.';
